import { z } from "zod";

export const MIN_PASSWORD_LENGTH = 8;

export const loginSchema = z.object({
	email: z.string().min(1, { message: "Email is required." }).email("This is not a valid email."),
	password: z.string().min(MIN_PASSWORD_LENGTH),
});

export const passwordSchema = z
	.string()
	.min(MIN_PASSWORD_LENGTH)
	.regex(/[A-Z]/, "Password must contain at least one uppercase letter")
	.regex(/[a-z]/, "Password must contain at least one lowercase letter")
	.regex(/[0-9]/, "Password must contain at least one number")
	.regex(/[^A-Za-z0-9]/, "Password must contain at least one special character");

export const emailSchema = z
	.string()
	.min(1, "Email is required")
	.email("Invalid email address")
	.max(255, "Email cannot exceed 255 characters");

export const changePasswordSchema = z.object({
	oldPassword: z.string().min(1, "Current password is required"),
	newPassword: passwordSchema,
});

export type LoginInput = z.infer<typeof loginSchema>;
